import { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import api from '@/lib/api';

// Read-only list: what each branch still needs before ZATCA production signing, plus its resolved timezone.
export const ZatcaSellerReadinessCard = () => {
  const [data, setData] = useState(null);
  const [tz, setTz] = useState({});
  useEffect(() => {
    api.get('/zatca-p2/seller-readiness').then((r) => setData(r.data)).catch(() => setData(null));
    api.get('/branches-timezones').then((r) => setTz(Object.fromEntries(r.data.map((x) => [x.branch_id, x])))).catch(() => {});
  }, []);
  if (!data) return null;
  return (
    <Card className="border-border" data-testid="zatca-seller-readiness-card">
      <CardHeader>
        <CardTitle className="font-outfit text-base">Seller details for ZATCA ({data.ready_count}/{data.branches.length} branches ready)</CardTitle>
        <p className="text-xs text-muted-foreground">Values come from the branch first, then the Company Profile. Suggested values (read from the company address text) must be confirmed in Company Profile → ZATCA address before signing.</p>
      </CardHeader>
      <CardContent className="overflow-x-auto">
        <table className="w-full text-sm" data-testid="zatca-readiness-table">
          <thead><tr className="text-left text-muted-foreground border-b"><th className="py-2 pr-3">Branch</th><th className="py-2 pr-3">Missing before signing</th><th className="py-2 pr-3">Timezone</th></tr></thead>
          <tbody>
            {data.branches.map((b) => {
              const t = tz[b.branch_id];
              return (
                <tr key={b.branch_id} className="border-b last:border-0" data-testid={`zatca-readiness-row-${b.branch_id}`}>
                  <td className="py-2 pr-3 font-medium">{b.branch_name}</td>
                  <td className="py-2 pr-3">{b.ready ? <Badge className="bg-success/20 text-success">Ready</Badge> : <span className="text-xs">{b.missing.join(', ')}</span>}</td>
                  <td className="py-2 pr-3 text-xs">{t ? (t.timezone ? `${t.timezone} (${t.source})` : <span className="text-warning">{t.note}</span>) : '—'}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </CardContent>
    </Card>
  );
};
